import dtImageNoWebp from './dtImageNoWebp';
import isDuitangImage from './isDuitangImage';
import { _dtImageTrans } from './__inner/image/_dtImageTrans';

/**
 * @description 缩放成指定宽度、高度自适应的图片 如果是webp转成非webp图片
 * @param url 图片地址
 * @param width 指定的宽度
 * @returns 处理后的图片地址
 */
const dtImageThumbNoWebp = (url: string, width: number): string => {
  const ret = _dtImageTrans(url, true, width, false);
  if (isDuitangImage(ret)) {
    dtImageNoWebp(ret);
  }
  return ret;
};

export default dtImageThumbNoWebp;
